import { render, staticRenderFns } from "./vue-tel-input-vuetify.vue?vue&type=template&id=5bcfdeca"
import script from "./vue-tel-input-vuetify.vue?vue&type=script&lang=js"
export * from "./vue-tel-input-vuetify.vue?vue&type=script&lang=js"
import style0 from "./sprite.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./vue-tel-input-vuetify.vue?vue&type=style&index=1&id=5bcfdeca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports